import React from 'react';
import './PayEducation.css';
import PDFPreviewCard from '../PDFPreviewCard/PDFPreviewCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const PayEducation = ({ pdfCards = [] }) => {
    const handleOpenPDF = (pdfUrl) => {
        window.open(pdfUrl, '_blank');
    };

    return (
        <section className="pay-education">
            <p className='direction-page__text'>Зачисление абиту​риентов на платное обучение проводится после:</p>
            <ul className='direction-page__list_with_icon'>
                <li className='direction-page__list-element'>
                    <FontAwesomeIcon icon={faCheckCircle} className='direction-page__list-icon'/>
                    Успешного прохождения вступительных испытаний и достижения проходных баллов;
                </li>
                <li className='direction-page__list-element'>
                    <FontAwesomeIcon icon={faCheckCircle} className='direction-page__list-icon'/>
                    Оформления договора;
                </li>
                <li className='direction-page__list-element'>
                    <FontAwesomeIcon icon={faCheckCircle} className='direction-page__list-icon'/>
                    Поступления оплаты за обучение (в соответствии с условиями договора на оказание образовательных услуг).
                </li>
            </ul>

            <div className='pay-education__pdf-container'>
                {pdfCards.map((card, index) => (
                    <div key={index} className='pay-education__card'>
                        <PDFPreviewCard
                            file={card.file}
                            onOpen={() => handleOpenPDF(card.file)}
                        />
                        <span className='pay-education__card-title'>{card.title}</span>
                    </div>
                ))}
            </div>

            <p className='direction-page__text'>
                Для заключения договора об оказани​и платных образовательных услуг вам необходимо иметь при себе документ, удостоверяющий личность.
                В случае, если договор заключается на одного из родителей или законных представителей, то необходимо присутствие и родителя (законного представителя) и поступающего.
            </p>
            <p className='direction-page__text'>
                Сроки оплаты обучения указаны в договоре. В случае оплаты обучения позднее установленных сроков зачисление не производится и договор будет расторгнут в одностороннем порядке после дня завершения процедуры зачисления.
            </p>
        </section>
    );
}

export default PayEducation;